import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/ticketCreate.css';
import useAlert from '../../hooks/useAlert';
import { CreateTicket, GetDispoDetials, uploadFiles } from '../../api';
import { onClickEvent } from '../../lib/gaAnalytics';
import {
  checkEngChars,
  CheckingValidComment,
  clickTracker,
  fileAllowedTypes,
  getCommentErrorMsg,
  getImgSrcUrl,
  getNonEnglishCharMsg,
  getProjectId,
} from '../../lib/common';
import { useAppState } from '../../contexts/appState';
import { handleSetTicketsData } from '../../reducersAndActions/actions/appStateActions';

export default function CategoriesTicketCreate() {
  const [, appDispatch] = useAppState();
  const navigate = useNavigate();
  const [fileData, setFileData] = useState([]);
  const [refFileData, setRefFileData] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [setAlert] = useAlert();
  const [loading, setLoading] = useState({ error: false, reference: false });
  const [issueComment, setIssueComment] = useState({ categories: '', description: '', websiteDescription: '' });
  const [dispositionData, setDispositionData] = useState([]);
  const queryParams = new URLSearchParams(window.location.search);
  const token = queryParams.get('token') || '';
  const projectId = getProjectId();

  const [selectedIssueSubIssue, setSelectedIssueSubIssue] = useState({
    selectedIssue: 'CATEGORIES ISSUES',
    selectedSubIssue: '',
  });
  const [issueSubIssueData, setIssueSubIssueData] = useState({
    issueData: selectedIssueSubIssue?.selectedIssue ? [selectedIssueSubIssue.selectedIssue] : ['Select Complaint'],
    subIssueData: ['Select Complaint Type'],
  });
  const selectedBusinessGenio = JSON.parse(localStorage.getItem('selectedBusinessGenio'));
  const profile = JSON.parse(sessionStorage.getItem('profileDetails'));

  const getSubIssueData = (dispoData) => {
    if (dispoData && dispoData.length > 0) {
      const subIssueRes = dispoData.filter((each) => {
        if (each.issue_type === 'CATEGORIES ISSUES') {
          return each;
        }
        return null;
      });

      const subIssueDataRes =
        subIssueRes &&
        subIssueRes[0] &&
        Object.keys(subIssueRes[0]).length > 0 &&
        subIssueRes[0]?.issue_sub_type &&
        Object.keys(subIssueRes[0]?.issue_sub_type).length > 0
          ? subIssueRes[0]?.issue_sub_type
          : {};
      return subIssueDataRes;
    }
    return [];
  };

  const handleResetFormFields = () => {
    const subIssueData = getSubIssueData(dispositionData);
    setSelectedIssueSubIssue({
      selectedIssue: 'CATEGORIES ISSUES',
      selectedSubIssue: '',
    });
    setIssueSubIssueData({
      ...issueSubIssueData,
      subIssueData: ['Select Complaint Type', ...subIssueData] || [],
    });
    setIssueComment({ categories: '', description: '' });
  };

  useEffect(() => {
    const handleGetDispoDetials = async () => {
      const dispoParams = {
        category: 'ccr',
        vertical: 'content',
        issue_flg: 'all',
      };

      try {
        const res = await GetDispoDetials(dispoParams, 1, projectId);
        setDispositionData(res || []);
        const dispoData = res || [];
        const issueDataRes = dispoData && dispoData.length > 0 ? dispoData.map((each) => each.issue_type) : [];
        const subIssueData = getSubIssueData(dispoData);
        setIssueSubIssueData({
          ...issueSubIssueData,
          issueData: [issueDataRes[0]],
          subIssueData: ['Select Complaint Type', ...subIssueData] || [],
        });
      } catch (err) {
        console.log('Error: ', err);
      }
    };
    handleGetDispoDetials();
  }, []);

  const handleFileUpload = async (event, data, arr, key) => {
    const file = event.target.files[0];
    onClickEvent(`CS-Create Ticket Page`, 'Attachment Uploaded', `Attachment Uploaded ${(file && file?.type) || ''}`);
    if (file && fileAllowedTypes.includes(file.type)) {
      const maxFileSize = file?.type === 'video/mp4' ? 50 : 5;
      if (file && file.size > maxFileSize * 1024 * 1024) {
        setAlert({
          message: `File size should not exceed ${maxFileSize} MB`,
          status: false,
        });
      } else {
        const files = event.target.files ? [...event.target.files] : [];
        const tempFileData = [...data];
        try {
          setLoading({ ...loading, [key]: true });
          const response = await uploadFiles(files, true);
          if (response.error_code === 0) {
            if ((response.image_urls && response.image_urls.length > 0) || file?.type === 'video/mp4') {
              tempFileData.push({
                name: files[0].name,
                url: file?.type === 'video/mp4' ? response?.url : response.image_urls[0],
              });
              arr(tempFileData);
            }
          } else {
            setAlert({
              message: 'Invalid file format',
              status: false,
            });
          }
          setLoading({ ...loading, [key]: false });
        } catch (err) {
          console.log('Error: ', err);
        }
      }
    } else {
      setAlert({
        message: 'Invalid file type. Please upload an Image, Excel, Word, PDF or Video(mp4) file.',
        status: false,
      });
    }
  };

  const handleSubmit = async (e) => {
    onClickEvent(`CS-Genio Category Create Ticket Page`, 'Ticket Submit', 'Ticket Submit');
    e.preventDefault();
    setIsSubmitting(true);
    const document = [];
    fileData.forEach((item) => {
      document.push({
        nm: `Error file - ${item.name}`,
        url: item.url,
      });
    });
    refFileData.forEach((item) => {
      document.push({
        nm: `Reference file - ${item.name}`,
        url: item.url,
      });

      document.push({
        nm: `Reference Website`,
        url: issueComment?.websiteDescription?.trim(),
      });
    });
    try {
      if (projectId === 'genio' && selectedBusinessGenio?.mobile) {
        const updatedComment = `Description: ${issueComment?.description?.trim() || ''}
        Categories: ${issueComment?.categories?.trim() || ''}`;
        if (issueComment.description.length > 15 && CheckingValidComment(issueComment.description)) {
          const params = {
            vertical: 'CONTENT',
            category: 'CCR',
            ticket_creator: 'BUSINESS',
            nm: selectedBusinessGenio?.contractPersonName || selectedBusinessGenio?.companyName || '',
            created_by: profile?.mobile || '',
            mob: selectedBusinessGenio?.mobile || '',
            issue_type: selectedIssueSubIssue?.selectedIssue || '',
            issue_sub_type: selectedIssueSubIssue?.selectedSubIssue || '',
            issue_comment: updatedComment || '',
            document,
            oid: '',
            orderid: '',
            city: selectedBusinessGenio?.city || '',
            docid: selectedBusinessGenio?.docId || '',
            src: 'sales-genio',
            src_typ: selectedBusinessGenio?.concern === 'client' ? 'client' : 'internal',
            src_nm: profile?.full_name || '',
            src_mob: profile?.mobile || '',
            projectId: '',
            parentId: selectedBusinessGenio.parentId || '',
            compnm: selectedBusinessGenio?.companyName || '',
            ...(projectId === 'genio' && {
              agent_mngr_id: profile?.reporteeCode,
              agent_id: profile?.empCode,
            }),
          };
          const res = await CreateTicket(params);
          const agentName = res?.result?.empdetails?.empname || res?.result?.empdetails?.empnm || 'Customer Support';
          const completeMessage = (
            <>
              {res?.result?.msg}
              <br />
              Agent: {agentName}
              <br />
              Contact: +917700-908366 <br />
              <br />{' '}
              <strong style={{ color: 'darkgrey' }}>
                All the raised tickets will be resolved within 15 minutes, kindly refrain from making calls.
              </strong>
            </>
          );
          if (res.errorCode === 0) {
            handleSetTicketsData(appDispatch, {
              ticketsData: res?.data || [],
            });
            setAlert({
              message: completeMessage,
              status: true,
            });
            if (projectId === 'genio') {
              // history.goBack();
              // Token for the New changes..
              if (token) {
                setTimeout(() => {
                  navigate('/genio', { replace: true });
                }, 2000);
              } else if (window.history.length === 2) {
                setTimeout(() => {
                  navigate('/genio');
                }, 5000);
              } else {
                navigate(-1);
              }
            }
          } else {
            setAlert({
              message: res?.message || (res?.result && res?.result?.msg) || 'Something Went Wrong!',
              status: false,
            });
            return;
          }
        } else {
          setAlert({
            message: 'Description length should be greater than 15 Characters.',
            status: false,
          });
          return;
        }
      } else if (projectId === 'genio') {
        setAlert({
          message: 'No Mobile number found in the contract. Validate with Database team.',
          status: false,
        });
        return;
      }
    } catch (err) {
      console.log('Error: ', err);
      setAlert({
        message: JSON.stringify(err),
        status: false,
      });
      setIsSubmitting(false);
    }
    setFileData([]);
    setRefFileData([]);
    handleResetFormFields();
    await clickTracker('CS-TicketCreate', 'leadDashBoard');
    setIsSubmitting(false);
  };

  const isValidUrl = (url) => {
    if (!url) return false;
    try {
      const parsed = new URL(url);
      return ['http:', 'https:'].includes(parsed.protocol);
    } catch (e) {
      return false;
    }
  };

  const enableSubmitButton =
    selectedIssueSubIssue.selectedIssue !== '' &&
    selectedIssueSubIssue.selectedSubIssue !== '' &&
    selectedIssueSubIssue.selectedSubIssue !== 'Select Complaint Type' &&
    CheckingValidComment(issueComment.description) &&
    issueComment.description.length < 3000 &&
    issueComment.categories.length > 0 &&
    issueComment.categories.length < 10000 &&
    fileData.length > 0 &&
    (refFileData.length > 0 || (issueComment.websiteDescription && isValidUrl(issueComment.websiteDescription))) &&
    !loading.error &&
    !loading.reference &&
    checkEngChars(issueComment.description) &&
    issueComment?.categories?.trim().length > 3 &&
    !getNonEnglishCharMsg(issueComment?.categories);

  const formFields = {
    dropDowns: {
      issue: {
        id: 'issue',
        label: 'Complaint',
        value: selectedIssueSubIssue.selectedIssue,
        data: issueSubIssueData.issueData,
        isDisabled: true,
        required: true,
      },
      subIssue: {
        id: 'subIssue',
        label: 'Complaint Type',
        value: selectedIssueSubIssue.selectedSubIssue,
        data: issueSubIssueData.subIssueData,
        isDisabled: issueSubIssueData.subIssueData.length < 1,
        required: true,
      },
    },
    descriptionField: {
      description: {
        id: 'description',
        value: issueComment.description,
        label: 'Description',
        required: true,
        placeholder: 'Please describe your issue and our team will get back within 24-48 hours',
      },
      categories: {
        id: 'categories',
        value: issueComment.categories,
        label: 'Categories',
        required: true,
        placeholder: 'Please mention the categories to be added to the docid',
      },

      websiteDescription: {
        id: 'websiteDescription',
        value: issueComment.websiteDescription,
        label: 'Upload Reference website or Reference image',
        required: true,
        placeholder: 'Please mention website here',
      },
    },
    attachments: {
      reference: {
        id: 'categories',
        label: ``,
        required: true,
        data: refFileData,
        arr: setRefFileData,
      },
      error: {
        id: 'description',
        label: `Upload 'Error type' file`,
        required: true,
        data: fileData,
        arr: setFileData,
      },
    },
  };

  const handleIssueSelect = (e, id) => {
    onClickEvent(`CS-Create Ticket Page-${id} Name`, e.target.value, e.target.value);
    if (id === 'issue') {
      setSelectedIssueSubIssue({ ...selectedIssueSubIssue, selectedIssue: e.target.value });
      // handleSelectedIssue(e.target.value);
    } else if (id === 'subIssue') {
      setSelectedIssueSubIssue({ ...selectedIssueSubIssue, selectedSubIssue: e.target.value.trim() });
    }
  };

  const deleteImage = (index, data, arr) => {
    const tempFileData = [...data];
    tempFileData.splice(index, 1);
    arr(tempFileData);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* <Header id="createTicket" /> */}
      <section className="cspage cslanding">
        <div className="newticket_wpr p-20 pb-80">
          {Object.keys(formFields).map((formKey) =>
            Object.keys(formFields[formKey]).map((keyValue, idx) =>
              formKey === 'descriptionField' ? (
                <div className="group mt-20" key={idx}>
                  <>
                    <label htmlFor={formFields[formKey][keyValue].id} className="description-label font14">
                      {`${formFields[formKey][keyValue].label}${formFields?.[formKey][keyValue]?.required ? '*' : ''} `}
                    </label>
                    <textarea
                      style={{ width: '100%' }}
                      value={formFields[formKey][keyValue].value}
                      className="csexpndwp_textarea font12 fw400 color111"
                      rows="4"
                      cols="50"
                      placeholder={formFields[formKey][keyValue].placeholder || ''}
                      onChange={(e) => {
                        setIssueComment({ ...issueComment, [formFields[formKey][keyValue].id]: e.target.value });
                      }}
                    />
                  </>
                  <span className="bar" />
                  {formFields[formKey][keyValue].id === 'description' &&
                    !CheckingValidComment(issueComment.description) &&
                    issueComment.description &&
                    issueComment.description.length > 3 && (
                      <span className="colorEC4 font12">{getCommentErrorMsg(issueComment?.description, 1)}</span>
                    )}

                  {formFields[formKey][keyValue].id === 'categories' &&
                    issueComment.categories &&
                    issueComment.categories.length > 3 && (
                      <span className="colorEC4 font12">{getNonEnglishCharMsg(issueComment?.categories, 1)}</span>
                    )}
                  {formFields[formKey][keyValue].id === 'websiteDescription' &&
                    issueComment.websiteDescription &&
                    !isValidUrl(issueComment.websiteDescription) && (
                      <span className="colorEC4 font12">Please enter a valid URL (example: https://example.com)</span>
                    )}
                </div>
              ) : formKey === 'dropDowns' ? (
                <>
                  <div className="group selectgroup mt-25 mb-10" key={idx}>
                    <select
                      onChange={(e) => handleIssueSelect(e, formFields[formKey][keyValue].id)}
                      className="inputMaterial font13 color11"
                      required
                      value={formFields[formKey][keyValue].value}
                      disabled={formFields[formKey][keyValue].isDisabled}
                      id="select"
                    >
                      {formFields[formKey][keyValue].data &&
                        formFields[formKey][keyValue].data.map((each, indx) => (
                          <option className="inputMaterial font12 color1a1" key={indx}>
                            {each}
                          </option>
                        ))}
                    </select>
                    <span className="bar" />
                    <label htmlFor="select" className="label-wrap font14 color11">
                      {`${formFields[formKey][keyValue].label}${formFields?.[formKey][keyValue]?.required ? '*' : ''} `}
                    </label>
                    <span className="downarrow rightposition" style={{ pointerEvents: 'none' }} />
                  </div>
                </>
              ) : formKey === 'attachments' ? (
                <div className="group phy_mandate_list uploadphoto mt-20 mb-15 mb-0">
                  {formFields[formKey][keyValue].label && formFields[formKey][keyValue].label.trim() !== '' && (
                    <p className="uploadtxt font14 pb-20">{`${formFields[formKey][keyValue].label} *`}</p>
                  )}

                  {formFields[formKey][keyValue].data && formFields[formKey][keyValue].data.length > 0 ? (
                    formFields[formKey][keyValue].data.map((each, i) => (
                      <span key={i} className="uploaded_img mr-10 mb-10">
                        <img key={i} alt={each.name} src={getImgSrcUrl(each.url)} />
                        <span className="uploaded_img_text font11 colorFFF">
                          <div
                            onClick={() =>
                              deleteImage(i, formFields[formKey][keyValue].data, formFields[formKey][keyValue].arr)
                            }
                            onKeyDown={() => {}}
                            className="ml-5"
                            key={idx}
                            role="button"
                            tabIndex="0"
                            aria-label="Delete image"
                            style={{ display: 'inline-block' }}
                          >
                            <img
                              alt="delete_img"
                              src="https://images.jdmagicbox.com/standard/cs_module/baf79d55c4951b13b60ebbb1c5f9e773.jpg"
                            />
                          </div>
                        </span>
                        <span className="uploaded_overlay" />
                      </span>
                    ))
                  ) : loading[keyValue] ? (
                    <span className="uploaded_img">
                      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                        <div className="bt-spinner" style={{ height: '25px', width: '25px' }} />
                      </div>
                    </span>
                  ) : null}

                  {formFields[formKey][keyValue].data && formFields[formKey][keyValue].data.length < 5 && (
                    <span className="uploaded_img">
                      <span className="upload_type_wpr color393 font11">
                        <input
                          type="file"
                          onChange={(e) =>
                            handleFileUpload(
                              e,
                              formFields[formKey][keyValue].data,
                              formFields[formKey][keyValue].arr,
                              keyValue,
                            )
                          }
                          onClick={(e) => {
                            e.target.value = null;
                          }}
                          name=""
                        />
                        <img alt="addPhoto" src="https://akam.cdn.jdmagicbox.com/images/icons/genio/gno_addphoto.svg" />
                      </span>
                    </span>
                  )}
                </div>
              ) : (
                <></>
              ),
            ),
          )}
          <div className="mandatebtns fullwidthbtn">
            <button
              className={`${!enableSubmitButton || isSubmitting ? 'mandatebtns_disabled' : 'mandatebtns_enable'}`}
              disabled={!enableSubmitButton || isSubmitting}
              type="button"
              onClick={handleSubmit}
            >
              Submit
            </button>
          </div>
        </div>
      </section>
    </>
  );
}
